import React from "react";
import { useLanguage } from "../hooks/useLanguage";

interface LanguageSwitcherProps {
  className?: string; // For contextual styling from parent components
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ className }) => {
  const { currentLanguage, supportedLanguages, languageNames, switchLanguage } =
    useLanguage();

  // If there's only one language, don't render the switcher.
  if (supportedLanguages.length < 2) {
    return null;
  }

  const handleLanguageSwitch = (lang: string) => {
    // Prevent reloading if the current language is clicked again
    if (lang === currentLanguage) return;
    switchLanguage(lang);
  };

  // The root element is our BEM block. The passed 'className' is for context.
  return (
    <div className={`language-switcher ${className || ""}`}>
      <div className="language-switcher__container">
        {supportedLanguages.map((lang) => (
          <button
            key={lang}
            onClick={() => handleLanguageSwitch(lang)}
            // BEM Element with a modifier for the active state
            className={`language-switcher__option ${
              lang === currentLanguage ? "is-active" : ""
            }`}
            aria-current={lang === currentLanguage ? "true" : "false"}
          >
            {languageNames[lang]?.toUpperCase() || lang}
          </button>
        ))}
      </div>
    </div>
  );
};

export default LanguageSwitcher;
